let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4IxSb")).then(() => parcelRequire('1Marh'));